module.exports = "https://bin.bnbstatic.com/_next/static/images/DOCK_app-EN-4016d4f93619003d6ccf71be2b880fc3.jpg";